import { Status } from '@/types';

type StatusCellProps = {
  status: Status;
};
const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
  const commonStyles =
    'inline-flex items-center rounded-md px-2 py-[0.5px] text-xs font-semibold';
  switch (status) {
    case 'Active':
      return (
        <span
          className={`${commonStyles} border-[1px] border-green-700 bg-green-100 text-green-800`}
        >
          Active
        </span>
      );

    case 'Deactivated':
    case 'Inactive':
      return (
        <span
          className={`${commonStyles} bg-gray-10 border-[1px] border-gray-700 text-charcoal`}
        >
          Deactivated
        </span>
      );
    case 'Pending':
      return (
        <span className={`${commonStyles}  bg-papaya-20 text-red-600`}>
          Pending
        </span>
      );

    case 'Suspended':
      return (
        <span
          className={`${commonStyles} bg-papaya-20 border-[1px] border-red-700 text-red-700`}
        >
          Suspended
        </span>
      );
    case 'Pending Activation':
      return (
        <span
          className={`${commonStyles} bg-orange-50 border-[1px] border-orange-200 text-orange-500`}
        >
          Pending Activation
        </span>
      );

    case 'Resolved':
      return (
        <span className={`${commonStyles} bg-teal-50 text-teal-700`}>
          Resolved
        </span>
      );
  }
};

export default StatusCell;
